import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rt-work',
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.scss']
})
export class WorkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
